const getBasePath = pathname =>
  pathname.substring(0, pathname.indexOf("/r/") + 3);

const getApiPath = pathname => pathname.substring(0, pathname.indexOf("/r/"));

export { getBasePath, getApiPath };
